export default __webpack_public_path__ + "assets/images/decor.15a161.webp";